import { useState, useContext, useEffect } from "react";
import { Drawer, Button, Modal } from "antd";
import { useHistory } from "react-router-dom";
import NavItem from "./NavItem";
import { logoutFromFirebase, setUserInfo } from "../actions";
import { StoreContext } from "../store";
import _ from "lodash";

export default function NavBar() {
    const { state: {userSignin: { userInfo }}, dispatch } = useContext(StoreContext);
    const [isOnTouch, setIsOnTouch] = useState(false);
    const handleCloseDrawer = () => setIsOnTouch(false);

    const history = useHistory();
    const Logout = () => {
        logoutFromFirebase(dispatch);
        history.push("/login");
    };

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <div className="nav-bar">
            {/* <HamMenu
                onClick={() => setIsOnTouch(!isOnTouch)}
                isOnTouch={isOnTouch}
            /> */}
            <div>
                <div className="account">
                    <img src="/images/account.png" className="accountpic"/>
                    <div className="account_name" value={userInfo[0].email}>{userInfo[0].email}</div>
                </div>
                <NavItem to="/autotestdis" className="nav-item" activeClassName="nav-item--active">
                    AUTO TEST
                </NavItem>
                {/* <NavItem to="/manualtest" className="nav-item" activeClassName="nav-item--active">
                    MANUAL TEST
                </NavItem> */}
                <Button
                    htmlType="submit"
                    className="logout_btn"
                    onClick={showModal}
                >
                    LOGOUT
                </Button>
                <Modal title="Diag Tool" visible={isModalVisible} onOk={Logout} onCancel={handleCancel}>
                    <p>Are you sure to logout without save?</p>
                </Modal>
            </div>
            <Drawer
                sticky="left"
                title=" "
                placement={"left"}
                closable={false}
                onClose={handleCloseDrawer}
                visible={isOnTouch}
                key={"left"}
                width={302}
                zIndex={99}
                bodyStyle={{ backgroundColor: "#004ea8" }}
                headerStyle={{ backgroundColor: "#004ea8", color: "#fff" }}
            >
            </Drawer>
        </div>
    );
}